import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vue2TouchEvents from 'vue2-touch-events'
import VueCookie from 'vue-cookie'
import Paginate from 'vuejs-paginate'
import Icon from 'vue-awesome/components/Icon'

import App from './App'
import router from './router'
import store from './store'
import locales from './locales'
import SimpleUI from './plugins/SimpleUI'

Vue.use(VueI18n)
Vue.use(Vue2TouchEvents)
Vue.use(SimpleUI)
Vue.use(VueCookie)

Vue.component('paginate', Paginate)
Vue.component('icon', Icon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n: new VueI18n(locales),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js